import React from 'react'

const ListMemberPlans = () => {
  return (
    <div>
      
    </div>
  )
}

export default React.memo(ListMemberPlans);
